


















import { Component, Mixins } from "vue-property-decorator";
import { RectangleDragHandles } from "../../../../../../base/components/dragging";
import { CircleDrawer } from "../../../../../../base/components/drawing/drawers";
import { Rectangle, Point, Size, PaintStyle, Color } from "../../../../../../base/domain/drawing";
import { CheckableObjectDrawerBase } from "./base";
import { CopyLinkedCheckBehaviorPropertyEditableMixin, LineStylePropertyEditableMixin } from "../../mixins/properties";

@Component({
  components: {
    CircleDrawer,
    RectangleDragHandles,
  },
})
export default class CircleSelectObjectDrawer extends Mixins(CheckableObjectDrawerBase, CopyLinkedCheckBehaviorPropertyEditableMixin, LineStylePropertyEditableMixin) {
  mounted() {
    this.styleKey = "CircleSelect";
  }

  get shapeRectangle(): Rectangle {
    return new Rectangle(
      new Point(0, 0),
      new Size(Math.max(this.offsetRectangleCoordinate.size.width, 1), Math.max(this.offsetRectangleCoordinate.size.height, 1)));
  }

  get textureStyle(): PaintStyle {
    return new PaintStyle(new Color("transparent"));
  }
}
